import styled from 'styled-components'
import { SwiperSlide as DefaultSwiperSlide } from 'swiper/react'
import { TextEllipsis } from '~/shared/ui/Text'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

export const SwiperSlide = styled(DefaultSwiperSlide)<{ $isBorder: boolean }>`
  width: 128px;
  height: 128px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  padding: 4px;

  ion-skeleton-text {
    top: -4px;
  }

  &::before {
    content: '';
    display: ${({ $isBorder }) => ($isBorder ? 'block' : 'none')};
    position: absolute;
    width: 126px;
    height: 126px;
    border: 1px solid ${myPalette.blue.main};
    border-radius: 14px;
    top: 0;
    left: 0;
  }
`

export const ImageWrapper = styled.div`
  width: 120px;
  height: 120px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
`

export const StoryContent = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;
  padding: 6px 0;
`

export const StoryContentBlur = styled.div`
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  --webkit-backdrop-filter: blur(4px);
  padding: 4px 6px;
  margin: 0 4px;
  border-radius: 8px;
`

export const TitleWrapper = styled(TextEllipsis)`
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 4px;
  color: ${myPalette.white.main};
`

export const DescriptionWrapper = styled(TextEllipsis)`
  font-size: 10px;
  font-weight: 500;
  color: ${myPalette.white.main};
`
